import script from "./UsernamePasswordReset.vue?vue&type=script&setup=true&lang=js"
export * from "./UsernamePasswordReset.vue?vue&type=script&setup=true&lang=js"

import "./UsernamePasswordReset.vue?vue&type=style&index=0&id=5a34389a&scoped=true&lang=css"

import exportComponent from "/home/interact/webapp/4.frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a34389a"]])

export default __exports__